import { MainMenu, SubMenuType } from 'rangeConfig/@types';
import ProductList from 'rangeConfig/shared/widgets/ProductList';
import ProductSwiper from 'rangeConfig/shared/widgets/ProductSwiper';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import interiorsProductListConfig from './productListConfig';
import platform from 'rangeConfig/shared/utils/platform';
import hideDoors from 'rangeConfig/shared/behaviors/hideDoors';
import showDoors from 'rangeConfig/shared/behaviors/showDoors';
import InteriorSuggestions from 'rangeConfig/ivar/widgets/InteriorSuggestions';
import withErrorMessage from 'rangeConfig/shared/widgets/withErrorMessage';
import { getNoFramesInSceneErrorMessage } from 'rangeConfig/shared/utils/errorMessages';
import ErrorMessageInline from 'rangeConfig/shared/widgets/ErrorMessageInline';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';
import { CoreApi } from '@inter-ikea-storageone/range';
import disableDistanceMeasurements from 'rangeConfig/shared/behaviors/disableDistanceMeasurements';
import enableDistanceMeasurements from 'rangeConfig/shared/behaviors/enableDistanceMeasurements';

const widgets = {
  desktop: [
    {
      id: 'error-message-no-frames-in-scene',
      component: withErrorMessage(getNoFramesInSceneErrorMessage)(ErrorMessageInline),
      hidden: (coreApi: CoreApi) => hideNoFramesInSceneErrorMessage(coreApi)
    }
  ],
  mobile: [
    {
      id: 'interior-suggestions',
      component: InteriorSuggestions,
      title: 'storageone.combinationsTabTitle'
    },
    {
      id: 'interiors-product-list',
      component: withProducts(ProductSwiper, interiorsProductListConfig),
      title: 'storageone.productListInteriorsTitle'
    }
  ]
};

const subMenu = {
  desktop: {
    type: SubMenuType.TABS,
    options: [
      {
        id: 'interiors-suggestions-tab',
        title: 'storageone.combinationsTabTitle',
        productThumbToolTip: 'name',
        widgets: [
          {
            id: 'interiors-suggestions',
            component: InteriorSuggestions
          }
        ]
      },
      {
        id: 'interior-list-tab',
        title: 'storageone.interiorSuggestionsInteriorsTabTitle',
        widgets: [
          {
            id: 'interior-list',
            component: withProducts(ProductList, interiorsProductListConfig)
          }
        ]
      }
    ]
  },
  mobile: undefined
};

const filters = {
  desktop: [],
  mobile: []
};

const mainMenu: MainMenu = {
  menuTitle: 'storageone.productListInteriorsTitle',
  behaviors: {
    productGroupEntered: [hideDoors, disableDistanceMeasurements],
    productGroupExited: [showDoors, enableDistanceMeasurements]
  },
  filters: filters[platform],
  widgets: widgets[platform],
  subMenu: subMenu[platform]
};

export default mainMenu;
